import { FlexCell, FlexRow, Text, IconContainer, Tooltip } from '@epam/promo';
import { StatisticsCardHeaderProps } from './StatisticsCardHeader.model';
import css from './StatisticsCardHeader.module.scss';

export const StatisticsCardHeader = ({
  title,
  range,
  tooltip,
}: StatisticsCardHeaderProps) => (
  <FlexRow>
    <Text cx={css['statistics-card__header']} size="42">
      <FlexRow>
        <FlexCell grow={2}>
          <FlexRow alignItems="center">
            {title.toUpperCase()}
            {tooltip && (
              <Tooltip content={tooltip} placement="top">
                <IconContainer cx={css.icon} />
              </Tooltip>
            )}
          </FlexRow>
        </FlexCell>
        {range && (
          <FlexCell grow={1}>
            <Text color="gray60" cx={css['statistics-card__range']} size="42">
              {range}
            </Text>
          </FlexCell>
        )}
      </FlexRow>
    </Text>
  </FlexRow>
);
